import { createApolloClient } from '@/clients/apollo';
import { contentfulAPIURL } from '@/clients/contentful';

const apiUrl = contentfulAPIURL(
  process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID || '',
  process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT || ''
);

export const apolloClient = createApolloClient(apiUrl, process.env.NEXT_PUBLIC_CONTENTFUL_CD_TOKEN || '');
const previewApolloClient = createApolloClient(apiUrl, process.env.NEXT_PUBLIC_CONTENTFUL_PREVIEW_TOKEN || '');

export function getClient(isPreview: boolean) {
  return isPreview ? previewApolloClient : apolloClient;
}
